import cx from "classnames";
import { motion } from "framer-motion";
import React from "react";

import { ANIMATION_DURATION, ANIMATION_EASE } from "@/constants/animations.constants";

interface PersonalisationScreenLayoutProps {
  header?: React.ReactNode;
  footer?: React.ReactNode;
  children: React.ReactNode;
  disableAnimation?: boolean;
  className?: string;
  contentClassName?: string;
  footerClassName?: string;
  style?: React.CSSProperties;
}

export const PersonalisationScreenLayout = ({
  header,
  footer,
  children,
  disableAnimation = false,
  className,
  contentClassName,
  footerClassName,
  style,
}: PersonalisationScreenLayoutProps) => {
  return (
    <div
      data-testid="PersonalisationScreenLayout"
      className={cx(
        "flex h-svh flex-col overflow-hidden pb-[env(safe-area-inset-bottom)] pt-[env(safe-area-inset-top)]",
        className,
      )}
    >
      <div className="w-full">{header}</div>
      <main className="flex flex-1 flex-col overflow-y-auto">
        {disableAnimation ? (
          <div className={cx("flex flex-1 flex-col", "gap-9 p-8", contentClassName)} style={style}>
            {children}
          </div>
        ) : (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{
              duration: ANIMATION_DURATION,
              delay: 0.1,
              ease: ANIMATION_EASE,
            }}
            className={cx("flex flex-1 flex-col", "gap-9 p-8", contentClassName)}
            style={style}
          >
            {children}
          </motion.div>
        )}
      </main>
      <div className={cx("flex w-full flex-col items-center gap-5 px-8 pb-4", footerClassName)}>
        {footer}
      </div>
    </div>
  );
};
